module.exports = __webpack_public_path__ + "img/cooperative0_logo17.09abc39e.jpg";